<template>
  <div class="zhanwei4"></div>
  <div class="container">
    <div class="form-group">
      <label for="visibility">显示设定:</label>
      <el-select placeholder="请选择" id="visibility" v-model="option">
        <el-option label="非公开" value="非公开"></el-option>
        <el-option label="公开" value="公开"></el-option>
      </el-select>

      <label for="price">价格:</label>
      <el-input
        placeholder="请输入内容"
        id="price"
        v-model="defaultPrice"
        type="number"
        style="width: 200px"
      >
        <template v-slot:append>元</template>
      </el-input>
    </div>
    <div class="info-group">
      <el-row>
        <el-col :span="12" v-if="form.id != null">
          <p><strong>正式版</strong></p>
          <!--          <p><a href="#">创作连结</a> | <a href="#">关卡 QR 码</a></p>-->
          <div class="qr-code">
            <vue-qr :text="qr_text" :size="200"></vue-qr>
          </div>
        </el-col>

        <el-col :span="12" class="info-details">
          <p><strong>地理位置:</strong> 任何地点 / 不限地区</p>
          <p v-if="form.createTime != null">
            <strong>建立时间:</strong> {{ form.createTime }}
          </p>
          <p>
            <strong v-if="form.releaseTime != null">发布时间:</strong>
            {{ form.releaseTime }}
          </p>
          <p>
            <strong>游玩状态:</strong>
            {{
              form.status == 0
                ? "审核中"
                : form.status == 1
                ? "已发布"
                : form.status == null
                ? "待发布"
                : "审核失败"
            }}
          </p>
          <p>
            <strong>版本号码:</strong>
            {{ form.version == null ? 0 : form.version }}
          </p>
          <p v-if="form.remark != null" style="color: red">
            <strong>备注:</strong> {{ form.remark }}
          </p>
        </el-col>
      </el-row>
    </div>
    <div class="button-group">
      <el-button type="primary" @click="releaseGame">发布新版本</el-button>
      <el-popover
        :width="150"
        popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
      >
        <template #reference>
          <div class="tiyan">
            <span>体验版</span>
            <span>
              <img
                style="width: 20px; height: 20px"
                src="../../image/qrcode.png"
                alt=""
              />
            </span>
          </div>
        </template>
        <template #default>
          <div
            class="demo-rich-conent"
            style="display: flex; gap: 16px; flex-direction: column"
          >
            <vue-qr :text="qr_text2" :size="600"></vue-qr>
          </div>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script lang="ts">
import { ElMessage, ElMessageBox } from "element-plus";
import { defineComponent } from "vue";
import vueQr from "vue-qr/src/packages/vue-qr.vue";

export default defineComponent({
  name: "release",
  data(): any {
    return {
      option: "",
      gameId: "",
      form: {
        id: "",
        publicStatus: 1,
        remark: null,
        gameLevelId: "",
        status: 0,
        version: 0,

        updateTime: "",
        releaseTime: "",
        createTime: "",
      },
      defaultPrice: 0,
      qr_text: "123",
      qr_text2: "123",
    };
  },
  components: {
    vueQr,
  },
  computed: {},
  watch: {},
  mounted() {
    const { id, detailId } = this.$route.params;
    this.gameId = id;
    this.initRelease(id);
  },
  methods: {
    initRelease(id: string) {
      this.$store
        .dispatch("game/getRelease", { releaseId: id })
        .then((res: any) => {
          res.remark = res.remark == "" ? null : res.remark;
          this.form = res;
          this.option = res.publicStatus == 1 ? "公开" : "非公开";
          this.defaultPrice = res.purchaseMoney;

          this.qr_text = `${res.id}&${res.publicStatus}`;
          this.qr_text2 = `${res.id}&test`;
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
    releaseGame() {
      ElMessageBox.confirm(
        "发布后，系统会自动建立资料包，使用者可从APP下载并开始体验！(资料包依大小可能会花费一定时间处理，请耐心等候，谢谢！",
        "确认发布",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
        }
      )
        .then(() => {
          const a = this.option == "公开" ? 1 : 0;
          this.$store
            .dispatch("game/releaseGame2", {
              gameId: this.gameId,
              price: this.defaultPrice < 0 ? 0 : this.defaultPrice,
              publicStatue: a,
            })
            .then((res: any) => {
              res.remark = res.remark == "" ? null : res.remark;
              this.form = res;
              this.defaultPrice = res.purchaseMoney;
              this.option = res.publicStatus == 1 ? "公开" : "非公开";
            })
            .catch((err: any) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
// 统一设计变量
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@success-color: #10b981;
@warning-color: #f59e0b;
@danger-color: #ef4444;

.zhanwei4 {
  height: 24px;
}

// 主卡片容器
.container {
  max-width: 860px;
  margin: 20px auto 40px;
  padding: 32px 36px;
  background-color: #ffffff;
  border: 1px solid @card-border;
  border-radius: 16px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04),
    0 2px 6px -1px rgba(15, 23, 42, 0.02);
  box-sizing: border-box;
}

// 顶部公开/非公开设定行
.form-group {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid @border-color;

  label {
    font-size: 14px;
    font-weight: 600;
    color: @text-main;
    user-select: none;
  }

  :deep(.el-select) {
    width: 180px;

    .el-input__wrapper {
      border-radius: 8px;
      box-shadow: 0 0 0 1px @border-color inset;
      padding: 4px 12px;

      &:hover,
      &.is-focus {
        box-shadow: 0 0 0 1px @primary-color inset !important;
      }
    }
  }
}

// 核心信息组展示
.info-group {
  margin-bottom: 36px;

  :deep(.el-row) {
    display: flex;
    align-items: stretch;
  }

  // 左侧二维码区域
  .el-col:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #f8fafc;
    border-radius: 12px;
    border: 1px solid @border-color;

    p {
      margin: 0 0 14px 0;
      font-size: 15px;
      font-weight: 700;
      color: @text-main;
      letter-spacing: 0.5px;
    }

    .qr-code {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      border: 1px solid @border-color;

      img,
      canvas {
        display: block;
        width: 170px !important;
        height: 170px !important;
      }
    }
  }

  // 右侧详情属性列表
  .info-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 36px;
    font-size: 14px;
    line-height: 1.8;

    p {
      margin: 8px 0;
      display: flex;
      align-items: center;
      color: @text-sub;

      strong {
        width: 80px;
        color: @text-muted;
        font-weight: 500;
        flex-shrink: 0;
      }
    }
  }
}

// 底部操作区
.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 16px;

  .el-button--primary {
    width: 200px;
    height: 44px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1px;
    background: @primary-color;
    border-color: @primary-color;
    box-shadow: 0 4px 14px rgba(93, 95, 239, 0.28);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: #4b4de0;
      border-color: #4b4de0;
      transform: translateY(-2px);
      box-shadow: 0 6px 18px rgba(93, 95, 239, 0.38);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// 体验版入口徽章
.tiyan {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: #f8fafc;
  border: 1px solid @border-color;
  border-radius: 20px;
  cursor: pointer;
  color: @text-sub;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;

  img {
    opacity: 0.7;
    transition: transform 0.2s ease;
  }

  &:hover {
    background: @primary-light;
    border-color: #dce2ff;
    color: @primary-color;

    img {
      opacity: 1;
      transform: scale(1.1);
    }
  }
}

// Popover 内部二维码容器
.demo-rich-conent {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;

  img,
  canvas {
    width: 100% !important;
    max-width: 160px !important;
    height: auto !important;
    border-radius: 6px;
  }
}
</style>
